const albumColors = {
    "Full Discography": {
        primaryColor: "#d4af37",
        secondaryColor: "#1a1a1a",
        textColor: "#ffffff",
        accentColor: "#f4e4c1",
        year: "2007-2024"
    },
    "Ronald Jenkees": {
        primaryColor: "#2c1810",
        secondaryColor: "#b69b8c",
        textColor: "#ffffff",
        accentColor: "#ffd700",
        year: "2007"
    },
    "Disorganized Fun": {
        primaryColor: "#4a2c2e",
        secondaryColor: "#c17f83",
        textColor: "#ffffff",
        accentColor: "#ffd700",
        year: "2009"
    },
    "Days Away": {
        primaryColor: "#1a1e3c",
        secondaryColor: "#8494cf",
        textColor: "#ffffff",
        accentColor: "#ffd700",
        year: "2012"
    },
    "Alpha Numeric": {
        primaryColor: "#e6c404",
        secondaryColor: "#8494b7",
        textColor: "#2c2c2c",
        accentColor: "#ffffff",
        year: "2014"
    },
    "Make It Fun Vol. 1": {
        primaryColor: "#181713",
        secondaryColor: "#d6b214",
        textColor: "#f1f9ec",
        accentColor: "#a9b2ff",
        year: "2016"
    },
    "Rhodes Deep": {
        primaryColor: "#2a1b34",
        secondaryColor: "#ff8e3c",
        textColor: "#ff9ec7",
        accentColor: "#ffd700",
        year: "2017"
    },
    "Wonder And Flow": {
        primaryColor: "#a7a8a2",
        secondaryColor: "#faf9f4",
        textColor: "#698694",
        accentColor: "#e1d8ce",
        year: "2024"
    }
};

let albums = [
    {
        name: "Full Discography",
        productId: "RJCD-ALL-DL",
        variantId: "52298416652563",
        isBundle: true,
        includedAlbums: ["10102698443027", "10102698508563", "10102698541331", "10102698574099", "10102698606867", "10102698639635", "52298416652563"],
        cover: null,
        subtitle: "The Complete Journey",
        description: "7 Albums • 108 tracks • Includes Bandcamp Codes",
        topFeature: "17 Years of Jams",
        middleFeature: "+ Bandcamp Codes",
        formatFeatures: ["MP3", "WAV", "FLAC"]
    },
    {
        name: "Ronald Jenkees",
        productId: "10102698443027",
        variantId: "52240139321619",
        cover: "https://cdn.shopify.com/s/files/1/0747/1180/7763/files/RJCD1_600_2.jpg?v=1744810437",
        tracks: [
            { title: "Derty", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_01._Derty_preview.mp3" },
            { title: "Neptune", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_02._Neptune_preview.mp3" },
            { title: "Canon In D Remix", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_03._Canon_in_D_Remix_preview.mp3" },
            { title: "Clutter", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_04._Clutter_preview.mp3" },
            { title: "Super-Fun", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_05._Super-Fun_preview.mp3" },
            { title: "Snap", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_07._Snap_preview.mp3" },
            { title: "The Sunfish Song", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_08._The_Sunfish_Song_preview.mp3" },
            { title: "Loui", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_09._Loui_preview.mp3" },
            { title: "Gold Spinners", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_10._Gold_Spinners_preview.mp3" },
            { title: "Remix To A Remix", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_11._Remix_To_A_Remix_preview.mp3" },
            { title: "Almost Undamaged", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_12._Almost_Undamaged_preview.mp3" },
            { title: "56K (Rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_13._56K_RAP_preview.mp3" },
            { title: "Ain't No Thang (Rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-1-License_-_Ronald_Jenkees_-_14._Aint_No_Thang_RAP_preview.mp3" }
        ]
    },
    {
        name: "Disorganized Fun",
        productId: "10102698508563",
        variantId: "52240139419923",
        cover: "https://cdn.shopify.com/s/files/1/0747/1180/7763/files/RJCD2_600.jpg?v=1744810202",
        tracks: [
            { title: "Disorganized Fun", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_01._Disorganized_Fun_preview.mp3" },
            { title: "Fifteen Fifty", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_02._Fifteen_Fifty_preview.mp3" },
            { title: "Guitar Sound", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_03._Guitar_Sound_preview.mp3" },
            { title: "Synth One", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_04._Synth_One_preview.mp3" },
            { title: "Throwing Fire", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_05._Throwing_Fire_preview.mp3" },
            { title: "Minimal MC", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_06._Minimal_MC_preview.mp3" },
            { title: "Stay Crunchy", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_07._Stay_Crunchy_preview.mp3" },
            { title: "Inverted Mean", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_08._Inverted_Mean_preview.mp3" },
            { title: "Outer Space", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_09._Outer_Space_preview.mp3" },
            { title: "Let's Ride (rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_10._Let's_Ride_preview.mp3" },
            { title: "It's Gettin Rowdy (rap)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-2-License_-_Ronald_Jenkees_Disorganized_Fun_-_11._It's_Gettin_Rowdy_preview.mp3" }
        ]
    },
    { 
        name: "Days Away",
        productId: "10102698541331",
        variantId: "52240139452691",
        cover: "https://cdn.shopify.com/s/files/1/0747/1180/7763/files/RJCD3_600.jpg?v=1744810199",
        tracks: [
            { title: "Magnetic Moment", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_01._Magnetic_Moment_preview.mp3" },
            { title: "Speaker 1, Speaker 1", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_02._Speaker_1,_Speaker_1_preview.mp3" },
            { title: "Sidetracked", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_03._Sidetracked_preview.mp3" },
            { title: "Early Morning May", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_04._Early_Morning_May_preview.mp3" },
            { title: "Supercell In Tune", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_05._Supercell_In_Tune_preview.mp3" },
            { title: "With Water and Light", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_06._With_Water_and_Light_preview.mp3" },
            { title: "7 Times", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_07._7_Times_preview.mp3" },
            { title: "Red Lemonade", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_08._Red_Lemonade_preview.mp3" },
            { title: "Days Away", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_09._Days_Away_preview.mp3" },
            { title: "Deep-Sea Sounding", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_10._Deep-Sea_Sounding_preview.mp3" },
            { title: "Error Me Out", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_11._Error_Me_Out_preview.mp3" },
            { title: "Piano Wire", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_12._Piano_Wire_preview.mp3" },
            { title: "Simpletank", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_13._Simpletank_preview.mp3" },
            { title: "From The Arrow Loop", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_14._From_The_Arrow_Loop_preview.mp3" },
            { title: "Red Lemonade Remixed", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-3-License_-_Ronald_Jenkees_Days_Away_-_15._Red_Lemonade_Remixed_preview.mp3" }
        ]
    },
    { 
        name: "Alpha Numeric",
        productId: "10102698574099",
        variantId: "52240139485459",
        cover: "https://cdn.shopify.com/s/files/1/0747/1180/7763/files/RJCD4_600_b9414a72-9842-4246-b4db-16492d9bbd91.jpg?v=1744811619",
        tracks: [
            { title: "Synergetics", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_01._Synergetics_preview.mp3" },
            { title: "Filter In", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_02._Filter_In_preview.mp3" },
            { title: "In Blue", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_03._In_Blue_preview.mp3" },
            { title: "Mr. Mac", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_04._Mr._Mac_preview.mp3" },
            { title: "Echo Out", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_05._Echo_Out_preview.mp3" },
            { title: "Alpha Numeric", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_06._Alpha_Numeric_preview.mp3" },
            { title: "Hotel Midi", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_07._Hotel_Midi_preview.mp3" },
            { title: "103 Degrees", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_08._103_Degrees_preview.mp3" },
            { title: "Slow To Spring", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_09._Slow_to_Spring_preview.mp3" },
            { title: "Fall Drift", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_10._Fall_Drift_preview.mp3" },
            { title: "All The Circles", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_11._All_The_Circles_preview.mp3" },
            { title: "Dream Happy", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4-License_-_Ronald_Jenkees_Alpha_Numeric_-_12._Dream_Happy_preview.mp3" }
        ]
    },
    { 
        name: "Make It Fun Vol. 1",
        productId: "10102698606867",
        variantId: "52240139518227",
        cover: "https://cdn.shopify.com/s/files/1/0747/1180/7763/files/RJCD4A_BC_600.jpg?v=1744810203",
        tracks: [
            { title: "Dr. Goose Robbins - No Lead - 125BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_01._Dr._Goose_Robbins_No_Lead_125BPM_preview.mp3" },
            { title: "Dr. Goose Robbins - No Drums - 125BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_02._Dr._Goose_Robbins_No_Drums_125BPM_preview.mp3" },
            { title: "Try The Bass - No Lead - 115BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_03._Try_The_Bass_No_Lead_115BPM_preview.mp3" },
            { title: "Try The Bass - No Drums - 115BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_04._Try_The_Bass_No_Drums_115BPM_preview.mp3" },
            { title: "Alpha Numeric - No Lead - 132BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_05._Alpha_Numeric_No_Lead_132BPM_preview.mp3" },
            { title: "Alpha Numeric - No Drums - 132BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_06._Alpha_Numeric_No_Drums_132BPM_preview.mp3" },
            { title: "Synergetics - No Lead - 130BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_07._Synergetics_No_Lead_130BPM_preview.mp3" },
            { title: "Synergetics - No Drums - 130BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_08._Synergetics_No_Drums_130BPM_preview.mp3" },
            { title: "Guitar Sound - No Guitar - 100BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_09._Guitar_Sound_No_Guitar_100BPM_preview.mp3" },
            { title: "Guitar Sound - No Drums - 100BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_10._Guitar_Sound_No_Drums_100BPM_preview.mp3" },
            { title: "Fall Drift - No Lead Piano - 120BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_11._Fall_Drift_No_Lead_Piano_120BPM_preview.mp3" },
            { title: "Fall Drift - No Drums - 120BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_12._Fall_Drift_No_Drums_120BPM_preview.mp3" },
            { title: "Disorganized Fun - No Lead - 98BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_13._Disorganized_Fun_No_Lead_98BPM_preview.mp3" },
            { title: "Disorganized Fun - No Drums - 98BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_14._Disorganized_Fun_No_Drums_98BPM_preview.mp3" },
            { title: "Throwing Fire - No Lead - 105BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_15._Throwing_Fire_No_Lead_105BPM_preview.mp3" },
            { title: "Throwing Fire - No Drums - 105BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_16._Throwing_Fire_No_Drums_105BPM_preview.mp3" },
            { title: "Stay Crunchy - No Lead - 140BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_17._Stay_Crunchy_No_Lead_140BPM_preview.mp3" },
            { title: "Stay Crunchy - No Drums - 140BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_18._Stay_Crunchy_No_Drums_140BPM_preview.mp3" },
            { title: "Outer Space - No Lead - 117BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_19._Outer_Space_No_Lead_117BPM_preview.mp3" },
            { title: "Outer Space - No Drums - 117BPM", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-4A-License_-_Ronald_Jenkees_Make_It_Fun_Vol_One_-_20._Outer_Space_No_Drums_117BPM_preview.mp3" }
        ]
    },
    { 
        name: "Rhodes Deep",
        productId: "10102698639635",
        variantId: "52240139550995",
        cover: "https://cdn.shopify.com/s/files/1/0747/1180/7763/files/RJCD4_600.jpg?v=1744810207",
        tracks: [
            { title: "Rhodes Deep", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_01._Rhodes_Deep_preview.mp3" },
            { title: "Dr. Goose Robbins", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_02._Dr._Goose_Robbins_preview.mp3" },
            { title: "Expensive Ice Chill Cuts Deluxe", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_03._Expensive_Ice_Chill_Cuts_Deluxe_preview.mp3" },
            { title: "Arp Island", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_04._Arp_Island_preview.mp3" },
            { title: "So Alive", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_05._So_Alive_preview.mp3" },
            { title: "So Alive (Instrumental)", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_06._So_Alive_(Instrumental)_preview.mp3" },
            { title: "Unusual Weather", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_07._Unusual_Weather_preview.mp3" },
            { title: "Spearmint", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_08._Spearmint_preview.mp3" },
            { title: "Try The Bass", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_09._Try_The_Bass_preview.mp3" },
            { title: "Aquatic Jambiance", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5-License_-_Ronald_Jenkees_Rhodes_Deep_-_10._Aquatic_Jambiance_preview.mp3" }
        ]
    },
    { 
        name: "Wonder And Flow",
        productId: "52298416652563",
        variantId: "52280858247443",
        cover: "https://cdn.shopify.com/s/files/1/0747/1180/7763/files/RJ4A_600.webp?v=1747373043",
        tracks: [
            { title: "Mindful", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_01_Mindful_preview.wav" },
            { title: "Sky Tied", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_02_Sky_Tied_preview.wav" },
            { title: "Wonder And Flow", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_03_Wonder_And_Flow_preview.wav" },
            { title: "Spark", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_04_Spark_preview.wav" },
            { title: "Right Behind You", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_05_Right_Behind_You_preview.wav" },
            { title: "Linden Flower", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_06_Linden_Flower_preview.wav" },
            { title: "Right Behind You 1.5", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_07_Right_Behind_You_1.5_preview.wav" },
            { title: "Nature November", preview: "https://storage.googleapis.com/jenkees/Audio/Previews/RJ-5A-Ronald_Jenkees_-_Wonder_And_Flow_08_Nature_November_preview.wav" }
        ]
    }
];

// Apply local cover mapping if provided by Liquid
if (window.RJ_ALBUM_COVERS_BY_NAME) {
    albums = albums.map(a => ({
        ...a,
        cover: window.RJ_ALBUM_COVERS_BY_NAME[a.name] || a.cover
    }));
}

let selectedAlbums = {};

// Audio playback state
let currentAudio = null;
let currentTrackElement = null;
let currentAlbumName = null;
let audioProgressInterval;
let activeAlbum = null;

if (!window.PRICE_DATA) {
    window.PRICE_DATA = {
        "timestamp": new Date().toISOString(),
        "prices": {
            "RJCD-ALL-DL": 34,
            "10102698443027": 10,
            "10102698508563": 10,
            "10102698541331": 10,
            "10102698574099": 10,
            "10102698606867": 2,
            "10102698639635": 10,
            "52298416652563": 8
        }
    };
}

function rjLoadAlbums() {
    const container = document.getElementById("rj-albumContainer");
    if (!container) {
        console.error("RJ Album container not found!");
        return;
    }
    
    container.innerHTML = '';
    
    const bundle = albums.find(a => a.isBundle);
    const singles = albums.filter(a => !a.isBundle).reverse();
    const albumsToLoad = bundle ? [bundle, ...singles] : singles;
    
    albumsToLoad.forEach(album => {
        const wrapper = document.createElement("div");
        wrapper.classList.add("rj-album-wrapper");
        
        const albumDiv = document.createElement("div");
        albumDiv.classList.add("rj-album");
        
        if (album.isBundle) {
            albumDiv.classList.add("rj-album-bundle");
            wrapper.classList.add("rj-bundle-wrapper");
        }
        
        const colors = albumColors[album.name];
        if (colors) {
            albumDiv.dataset.primaryColor = colors.primaryColor;
            albumDiv.dataset.secondaryColor = colors.secondaryColor;
            albumDiv.dataset.textColor = colors.textColor;
            albumDiv.dataset.accentColor = colors.accentColor;
            albumDiv.dataset.year = colors.year;
        }
        
        if (album.isBundle) {
            const formatPills = Array.isArray(album.formatFeatures) && album.formatFeatures.length
                ? `<div class="rj-bundle-pill-row">${album.formatFeatures.map(format => `<span class="rj-bundle-pill rj-bundle-pill-small">${format}</span>`).join('')}</div>`
                : '';

            const pillMarkupParts = [
                album.topFeature ? `<div class="rj-bundle-pill rj-bundle-pill-top">${album.topFeature}</div>` : '',
                formatPills,
                album.middleFeature ? `<div class="rj-bundle-pill rj-bundle-pill-bottom">${album.middleFeature}</div>` : ''
            ].filter(Boolean);

            const renderedPills = pillMarkupParts.length
                ? `<div class="rj-bundle-pill-stack">${pillMarkupParts.join('')}</div>`
                : '';

            const pillLabelParts = [
                album.topFeature,
                Array.isArray(album.formatFeatures) && album.formatFeatures.length ? album.formatFeatures.join(', ') : '',
                album.middleFeature
            ].filter(Boolean);

            const pillsAriaLabel = pillLabelParts.length ? pillLabelParts.join(' • ') : (album.description || '');

            albumDiv.innerHTML = `
                <div class="rj-checkbox-overlay">
                    <label>
                        <input type="checkbox" class="rj-album-select-checkbox rj-bundle-checkbox" value="${album.productId}" data-included-albums='${JSON.stringify(album.includedAlbums)}' onclick="event.stopPropagation();" onchange="rjUpdateBundleSelection(this, event)">
                    </label>
                </div>
                <div class="rj-bundle-content">
                    <div class="rj-bundle-title" aria-label="Full Discography">FULL<wbr> DISCOGRAPHY</div>
                    <div class="rj-bundle-divider"></div>
                    <div class="rj-bundle-subtitle" title="${album.subtitle}">${album.subtitle}</div>
                    <div class="rj-bundle-description"${pillsAriaLabel ? ` aria-label="${pillsAriaLabel}"` : ''}>
                        ${renderedPills}
                    </div>
                </div>
                <div class="rj-price-tag rj-bundle-price" data-product-id="${album.productId}" data-track-count="108">
                    <span class="rj-price-amount">$34</span>
                </div>
            `;
        } else {
            const tracksHtml = album.tracks ? `
                <div class="rj-album-tracks" onclick="event.stopPropagation();">
                    ${album.tracks.map((track, index) => `
                        <div class="rj-track" id="rj-track-${album.productId}-${index}" 
                            onclick="rjPlayPreview('${track.preview}', this, 'rj-track-${album.productId}-${index}', '${album.name}', event)"
                            ontouchend="rjPlayPreview('${track.preview}', this, 'rj-track-${album.productId}-${index}', '${album.name}', event)">
                            <span class="rj-track-number">${(index + 1).toString().padStart(2, '0')}</span>
                            <span class="rj-track-title">${track.title}</span>
                            <div class="rj-audio-wave">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    `).join('')}
                </div>
            ` : '';

            albumDiv.innerHTML = `
                <div class="rj-checkbox-overlay">
                    <label>
                        <input type="checkbox" class="rj-album-select-checkbox" value="${album.productId}" onclick="event.stopPropagation();" onchange="rjUpdateSelection(this, event)">
                    </label>
                </div>
                <div class="rj-album-image">
                    <img src="${album.cover}" alt="${album.name}" onerror="this.onerror=null; this.src=(window.RJ_ALBUM_COVERS_FALLBACK||this.src)">
                </div>
                <div class="rj-album-info">
                    <p>${album.name}</p>
                    <span class="rj-track-count">${album.tracks ? album.tracks.length : 0} tracks</span>
                </div>
                <div class="rj-price-tag" data-product-id="${album.productId}" data-track-count="${album.tracks ? album.tracks.length : 0}">
                    <span class="rj-price-amount">$10</span>
                </div>
                <div class="rj-play-indicator">
                    <svg class="rj-play-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 4v14l11-7z" fill="none" stroke="#888888" stroke-width="1.4" stroke-linejoin="round"/>
                    </svg>
                </div>
                ${tracksHtml}
            `;
        }
        
        wrapper.appendChild(albumDiv);
        container.appendChild(wrapper);
    });

    rjUpdatePriceDisplay(window.PRICE_DATA?.prices || {
        "10102698443027": 10,
        "10102698508563": 10,
        "10102698541331": 10,
        "10102698574099": 10,
        "10102698606867": 2,
        "10102698639635": 10,
        "52298416652563": 8
    });

    document.querySelectorAll('.rj-album').forEach(album => {
        album.addEventListener('click', function(event) {
            if (event.target.closest('.rj-checkbox-overlay')) {
                return;
            }

            const wasExpanded = this.classList.contains('rj-expanded');
            const currentlyExpanded = document.querySelector('.rj-album.rj-expanded');

            if (currentlyExpanded && currentlyExpanded !== this) {
                currentlyExpanded.classList.remove('rj-expanded');
                rjStopAudio();
            }

            if (!wasExpanded) {
                this.classList.add('rj-expanding');
                
                setTimeout(() => {
                    this.classList.add('rj-expanded');
                    this.classList.remove('rj-expanding');
                }, 40);
                
                setTimeout(() => {
                    const albumRect = this.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    
                    if (albumRect.bottom > window.innerHeight - 200) {
                        const newPosition = scrollTop + albumRect.top - 120;
                        window.scrollTo({
                            top: newPosition,
                            behavior: 'smooth'
                        });
                    }
                }, 300);
                
                event.stopPropagation();
            } else {
                this.classList.add('rj-closing');
                
                setTimeout(() => {
                    this.classList.remove('rj-expanded');
                    
                    setTimeout(() => {
                        this.classList.remove('rj-closing');
                    }, 400);
                    
                    rjStopAudio();
                }, 40);
            }
        });
    });
}

// Function to update price display
function rjUpdatePriceDisplay(prices) {
    if (!prices) return;
    
    document.querySelectorAll('.rj-price-tag').forEach(priceTag => {
        const productId = priceTag.getAttribute('data-product-id');
        const priceAmount = priceTag.querySelector('.rj-price-amount');
        
        if (!priceAmount) return;
        
        const price = prices[productId];
        
        if (price !== undefined) {
            priceAmount.textContent = `$${Math.round(price)}`;
            priceTag.setAttribute('data-price', price);
        } else {
            priceAmount.textContent = '$10';
        }
    });
    
    rjUpdateSelectionPrices();
}

// Function to update prices in selections
function rjUpdateSelectionPrices() {
    const selectedAlbums = document.querySelectorAll('.rj-album-select-checkbox:checked');
    if (selectedAlbums.length > 0) {
        rjUpdateSelection(selectedAlbums[0]);
    }
}

function rjClearGhostIndicators() {
    document.querySelectorAll('.rj-checkbox-overlay.rj-ghost').forEach(overlay => {
        overlay.classList.remove('rj-ghost');
    });
}

function rjToggleBundleGhostIndicators(enable) {
    const bundle = albums.find(album => album.isBundle);
    if (!bundle || !Array.isArray(bundle.includedAlbums)) {
        rjClearGhostIndicators();
        return;
    }

    if (!enable) {
        rjClearGhostIndicators();
        return;
    }

    rjClearGhostIndicators();

    bundle.includedAlbums.forEach(albumId => {
        const albumCheckbox = document.querySelector(`.rj-album-select-checkbox[value="${albumId}"]`);
        if (!albumCheckbox) {
            return;
        }

        const album = albumCheckbox.closest('.rj-album');
        if (!album) {
            return;
        }

        const overlay = album.querySelector('.rj-checkbox-overlay');
        if (overlay) {
            overlay.classList.add('rj-ghost');
        }
    });
}

function rjUpdateBundleSelection(bundleCheckbox, event) {
    if (event) {
        event.stopPropagation();
    }

    const includedAlbums = JSON.parse(bundleCheckbox.getAttribute('data-included-albums'));

    if (bundleCheckbox.checked) {
        includedAlbums.forEach(albumId => {
            const albumCheckbox = document.querySelector(`.rj-album-select-checkbox[value="${albumId}"]`);
            if (albumCheckbox && albumCheckbox.checked) {
                albumCheckbox.checked = false;
                rjUpdateSelection(albumCheckbox, null, { skipBundleSync: true });
            }
        });
    }
    
    rjUpdateSelection(bundleCheckbox, null);
}

function rjUpdateSelection(checkbox, event, options) {
    if (event) {
        event.stopPropagation();
    }

    const skipBundleSync = options && typeof options === 'object' ? options.skipBundleSync === true : false;
    const skipAutoConversion = options && typeof options === 'object' ? options.skipAutoConversion === true : false;

    if (!skipBundleSync && checkbox.value !== 'RJCD-ALL-DL') {
        const bundleCb = document.querySelector('.rj-bundle-checkbox');
        const bundleMeta = albums.find(a => a.isBundle);
        if (bundleCb && bundleCb.checked && bundleMeta && Array.isArray(bundleMeta.includedAlbums)) {
            document.querySelectorAll('[data-bundle-parent="RJCD-ALL-DL"]').forEach(node => node.remove());
            bundleCb.checked = false;
            rjUpdateSelection(bundleCb, null, { skipBundleSync: true, skipAutoConversion: true });

            const singlesToKeep = bundleMeta.includedAlbums.filter(id => id !== checkbox.value);
            singlesToKeep.forEach(id => {
                const singleCb = document.querySelector(`.rj-album-select-checkbox[value="${id}"]`);
                if (!singleCb || singleCb.checked) return;
                singleCb.checked = true;
                rjUpdateSelection(singleCb, null, { skipBundleSync: true, skipAutoConversion: true });
            });

            checkbox.checked = false;
            rjUpdateSelection(checkbox, null, { skipBundleSync: true, skipAutoConversion: true });
            return;
        }
    }
    
    const albumDiv = checkbox.closest('.rj-album');
    const overlay = albumDiv.querySelector('.rj-checkbox-overlay');
    const selectedAlbumsContainer = document.querySelector('.rj-selected-products');
    const emptyMessage = document.querySelector('.rj-empty-selection-message');
    
    if (checkbox.checked) {
        overlay.classList.add('rj-checked');
        checkbox.setAttribute("data-selected", "true");
        overlay.setAttribute("data-selected", "true");
        
        const albumTitleEl = albumDiv.querySelector('.rj-album-info p');
        const albumName = albumTitleEl ? albumTitleEl.textContent : 'Full Discography';
        const albumData = albums.find(a => a.productId === checkbox.value);
        const colors = albumColors[albumName];
        if (colors && colors.primaryColor) {
            albumDiv.style.boxShadow = `0 0 0 2px ${colors.primaryColor}, 0 4px 12px ${colors.primaryColor}33`;
        }

        if (albumDiv.classList.contains('rj-album-bundle')) {
            const bundleAlbums = Array.isArray(albumData?.includedAlbums) ? albumData.includedAlbums : [];
            const bundleShadow = colors?.primaryColor || '#d4af37';
            bundleAlbums.forEach(childId => {
                const childData = albums.find(a => a.productId === childId);
                const childName = childData?.name || '';
                const childCheckbox = document.querySelector(`.rj-album-select-checkbox[value="${childId}"]`);
                const childAlbumCard = childCheckbox ? childCheckbox.closest('.rj-album') : null;
                const childImgEl = childAlbumCard ? childAlbumCard.querySelector('img') : null;
                const childCover = childData?.cover || childImgEl?.src || '';

                const childThumbnail = document.createElement('div');
                childThumbnail.classList.add('rj-selected-thumbnail');
                childThumbnail.setAttribute('data-product-id', `${checkbox.value}::${childId}`);
                childThumbnail.setAttribute('data-bundle-parent', checkbox.value);
                childThumbnail.innerHTML = `
                    <div style="
                        position: relative;
                        width: 60px;
                        height: 60px;
                        border-radius: 8px;
                        overflow: hidden;
                        box-shadow: 0 0 0 2px ${bundleShadow};
                    ">
                        <img src="${childCover}" alt="${childName}" style="width: 100%; height: 100%; object-fit: cover;">
                    </div>
                `;
                selectedAlbumsContainer.appendChild(childThumbnail);
            });
        } else {
            const albumImg = albumDiv.querySelector('img');
            const thumbnail = document.createElement('div');
            thumbnail.classList.add('rj-selected-thumbnail');
            thumbnail.setAttribute('data-product-id', checkbox.value);
            thumbnail.innerHTML = `
                <div style="
                    position: relative;
                    width: 60px;
                    height: 60px;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 0 0 2px ${colors && colors.primaryColor ? colors.primaryColor : '#4e94cb'};
                ">
                    <img src="${albumImg ? albumImg.src : ''}" alt="${albumName}" style="width: 100%; height: 100%; object-fit: cover;">
                </div>
            `;
            selectedAlbumsContainer.appendChild(thumbnail);
        }

        if (checkbox.value === 'RJCD-ALL-DL') {
            rjToggleBundleGhostIndicators(true);
        }

        // Hide empty message and show subtotal
        if (emptyMessage) {
            emptyMessage.style.display = 'none';
        }
        
        // Show subtotal wrapper
        const subtotalWrapper = document.querySelector('.rj-subtotal-wrapper');
        if (subtotalWrapper) {
            subtotalWrapper.style.display = 'block';
        }
        
    } else {
        overlay.classList.remove('rj-checked');
        checkbox.removeAttribute("data-selected");
        overlay.removeAttribute("data-selected");
        
                albumDiv.style.boxShadow = '0 0 0 2px transparent';
        if (albumDiv.classList.contains('rj-album-bundle')) {
            selectedAlbumsContainer.querySelectorAll(`[data-bundle-parent="${checkbox.value}"]`).forEach(node => node.remove());
        } else {
            const thumbnail = selectedAlbumsContainer.querySelector(`[data-product-id="${checkbox.value}"]`);
            if (thumbnail) {
                thumbnail.remove();
            }
        }

        if (checkbox.value === 'RJCD-ALL-DL') {
            rjToggleBundleGhostIndicators(false);
        }
    }
    
    const selectedCheckboxes = document.querySelectorAll('.rj-album-select-checkbox:checked');

    const bundleCheckbox = document.querySelector('.rj-bundle-checkbox');
    const bundleData = albums.find(a => a.isBundle);
    const allSinglesSelected = bundleData && Array.isArray(bundleData.includedAlbums) && bundleData.includedAlbums.length > 0 && bundleData.includedAlbums.every(id => {
        return Array.from(selectedCheckboxes).some(cb => cb.value === id);
    });

    if (!skipAutoConversion && allSinglesSelected && bundleCheckbox && !bundleCheckbox.checked) {
        selectedCheckboxes.forEach(cb => {
            if (cb.value !== 'RJCD-ALL-DL') {
                cb.checked = false;
                rjUpdateSelection(cb, null, { skipBundleSync: true, skipAutoConversion: true });
            }
        });
        bundleCheckbox.checked = true;
        rjUpdateBundleSelection(bundleCheckbox);
        return;
    }

    let totalPrice = 0;
    let totalTracks = 0;
    
    selectedCheckboxes.forEach(cb => {
        const album = cb.closest('.rj-album');
        const priceTag = album.querySelector('.rj-price-tag');
        let price = 0;
        
        if (priceTag && priceTag.hasAttribute('data-price')) {
            price = parseFloat(priceTag.getAttribute('data-price')) || 0;
        } else if (priceTag) {
            const priceAmount = priceTag.querySelector('.rj-price-amount');
            if (priceAmount && priceAmount.textContent) {
                const priceText = priceAmount.textContent.trim();
                if (priceText && !priceText.includes("Loading")) {
                    price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
                }
            }
        }
        
        totalPrice += price;

        // Bundle has no per-album track list; force 108 tracks for totals
        if (cb.value === 'RJCD-ALL-DL') {
            totalTracks += 108;
        } else {
            const trackCountEl = album.querySelector('.rj-track-count');
            const trackCountText = trackCountEl ? trackCountEl.textContent : '';
            const trackCount = parseInt(trackCountText.match(/\d+/)?.[0] || '0');
            totalTracks += trackCount;
        }
    });
    
    const amountElement = document.querySelector('.rj-total-amount .rj-amount');
    if (amountElement) {
        const oldPrice = parseInt(amountElement.textContent);
        if (oldPrice !== Math.round(totalPrice)) {
            amountElement.classList.add('rj-value-changed');
            setTimeout(() => {
                amountElement.classList.remove('rj-value-changed');
            }, 300);
        }
        amountElement.textContent = Math.round(totalPrice);
    }
    
    const trackCountElement = document.getElementById('rj-trackCount');
    if (trackCountElement) {
        const oldTrackCount = parseInt(trackCountElement.textContent);
        
        if (oldTrackCount !== totalTracks) {
            trackCountElement.classList.add('rj-value-changed');
            setTimeout(() => {
                trackCountElement.classList.remove('rj-value-changed');
            }, 300);
        }
        
        trackCountElement.textContent = totalTracks;
    }
    
    if (emptyMessage) {
        emptyMessage.style.display = selectedCheckboxes.length === 0 ? 'block' : 'none';
    }
    
    const orderSummarySection = document.getElementById('rj-order-summary-section');
    if (orderSummarySection) {
        orderSummarySection.style.display = selectedCheckboxes.length === 0 ? 'none' : 'block';
    }
    
    const subtotalWrapper = document.querySelector('.rj-subtotal-wrapper');
    if (subtotalWrapper) {
        subtotalWrapper.style.display = selectedCheckboxes.length === 0 ? 'none' : 'block';
    }
    
    const addToCartBtn = document.getElementById('rj-addToCartBtn');
    if (addToCartBtn) {
        addToCartBtn.disabled = selectedCheckboxes.length === 0;
    }
}



function rjValidateCheckout() {
    const selectedAlbums = document.querySelectorAll(".rj-album-select-checkbox:checked");
    
    if (selectedAlbums.length === 0) {
        rjShowToast("Please select at least one album to download.", "error");
        
        const albumContainer = document.getElementById('rj-albumContainer');
        if (albumContainer) {
            albumContainer.style.boxShadow = '0 0 0 2px #f44336';
            albumContainer.style.transition = 'box-shadow 0.3s ease';
            
            if (window.innerWidth <= 480) {
                window.scrollTo({
                    top: albumContainer.offsetTop - 60,
                    behavior: 'smooth'
                });
            } else {
                albumContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            
            setTimeout(() => {
                albumContainer.style.boxShadow = '';
            }, 2000);
        }
        
        return false;
    }
    
    rjAddToShopifyCart();
    return true;
}

function rjAddToShopifyCart() {
    try {
        const selectedCheckboxes = document.querySelectorAll(".rj-album-select-checkbox:checked");
        
        if (selectedCheckboxes.length === 0) {
            rjShowToast("Please select at least one album.", "error");
            return;
        }

        let cartItems = [];
        
        const variantMap = {
            "RJCD-ALL-DL": "52280858247443",
            "10102698443027": "52240139321619", // Ronald Jenkees (RJCD1-RJ-DL)
            "10102698508563": "52240139419923", // Disorganized Fun (RJCD2-DF-DL)
            "10102698541331": "52240139452691", // Days Away (RJCD3-DA-DL)
            "10102698574099": "52240139485459", // Alpha Numeric (RJCD4-AN-DL)
            "10102698606867": "52240139518227", // Make It Fun Vol. 1 (RJ-4A-DL)
            "10102698639635": "52240139550995", // Rhodes Deep (RJCD4-RD-DL)
            "52298416652563": "52298416652563"  // Wonder and Flow (RJ-4A-DL)
        };
        
        const bundleSelected = Array.from(selectedCheckboxes).some(cb => cb.value === 'RJCD-ALL-DL');

        if (bundleSelected) {
            cartItems = [{
                id: variantMap["RJCD-ALL-DL"],
                quantity: 1
            }];
        } else {
            selectedCheckboxes.forEach(checkbox => {
                const productId = checkbox.value;
                const variantId = variantMap[productId] || productId;
                
                cartItems.push({
                    id: variantId,
                    quantity: 1
                });
            });
        }

        fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error(`Cart fetch failed: ${response.status} ${response.statusText}`);
            }
            return response.json();
        })
        .then(currentCart => {
            const selectedVariantIds = new Set(cartItems.map(item => item.id));
            const existingDownloadItems = [];
            
            if (currentCart.items && currentCart.items.length > 0) {
                currentCart.items.forEach(item => {
                    if (Object.values(variantMap).includes(item.variant_id.toString())) {
                        existingDownloadItems.push({
                            id: item.id,
                            variant_id: item.variant_id.toString(),
                            quantity: item.quantity
                        });
                    }
                });
            }
            
            const operations = [];
            if (existingDownloadItems.length > 0) {
                existingDownloadItems.forEach(item => {
                    operations.push({
                        type: 'remove',
                        data: {
                            id: item.id,
                            quantity: 0
                        }
                    });
                });
            }
            
            if (cartItems.length > 0) {
                operations.push({
                    type: 'add',
                    data: {
                        items: cartItems
                    }
                });
            }
            
            if (operations.length === 0) {
                rjShowToast("Your selections are ready for checkout!", "success");
                setTimeout(() => {
                    window.location.href = '/checkout';
                }, 1000);
                return Promise.resolve(null);
            }
            
            let statusMessage = "";
            if (existingDownloadItems.length > 0 && cartItems.length > 0) {
                statusMessage = `Updating ${cartItems.length} albums in cart...`;
            } else if (cartItems.length > 0) {
                statusMessage = `Adding ${cartItems.length} albums to cart...`;
            } else if (existingDownloadItems.length > 0) {
                statusMessage = `Removing ${existingDownloadItems.length} albums from cart...`;
            }
            rjShowToast(statusMessage, "success");
            
            return rjExecuteCartOperations(operations);
        })
        .then(result => {
            if (result !== null) {
                console.log('Cart operations completed successfully, redirecting to checkout...');
                
                setTimeout(() => {
                    console.log('Cart operations completed, verifying cart state before checkout...');
                    
                    fetch('/cart.js')
                    .then(response => response.json())
                    .then(finalCart => {
                        console.log('Final cart state before checkout:', finalCart);
                        console.log('Cart item count:', finalCart.item_count);
                        console.log('Cart items:', finalCart.items);
                        
                        if (finalCart.item_count > 0) {
                            console.log('Cart verified with items, redirecting to checkout...');
                            window.location.href = '/checkout';
                        } else {
                            console.error('Cart appears empty after operations');
                            rjShowToast('Cart appears empty. Please try adding items again.', 'error');
                        }
                    })
                    .catch(cartError => {
                        console.error('Error verifying final cart state:', cartError);
                        console.log('Proceeding with checkout redirect anyway...');
                        window.location.href = '/checkout';
                    });
                }, 400);
            }
        })
        .catch(error => {
            console.error('Error with cart synchronization:', error);
            console.error('Error details:', error.message);
            console.error('Error stack:', error.stack);
            rjShowToast(`Cart error: ${error.message}. Please try again.`, "error");
        });

    } catch (err) {
        console.error('Cart error:', err);
        rjShowToast("An error occurred. Please try again.", "error");
    }
}

function rjShowToast(message, type = "") {
    const toast = document.getElementById("rj-toast");
    if (!toast) return;
    
    toast.textContent = message;
    toast.className = `rj-toast ${type}`;
    toast.style.display = "block";
    toast.classList.add("rj-show");
    
    setTimeout(() => {
        if (toast) {
            toast.classList.remove("rj-show");
            setTimeout(() => {
                toast.style.display = "none";
            }, 300);
        }
    }, 3000);
}

async function rjExecuteCartOperations(operations) {
    try {
        console.log('Executing cart operations:', operations);
        
        const updates = {};
        let hasRemoveOperations = false;
        let addItems = [];
        
        for (const operation of operations) {
            if (operation.type === 'remove') {
                updates[operation.data.id] = 0;
                hasRemoveOperations = true;
                console.log(`Removing item ID ${operation.data.id} from cart`);
            } else if (operation.type === 'add') {
                addItems = addItems.concat(operation.data.items);
                console.log(`Adding items to cart:`, operation.data.items);
            }
        }
        
        if (hasRemoveOperations) {
            console.log('Sending remove request with updates:', updates);
            const removeResponse = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ updates })
            });
            
            if (!removeResponse.ok) {
                const errorText = await removeResponse.text();
                console.error('Remove operation failed:', removeResponse.status, errorText);
                throw new Error(`Failed to remove items: ${removeResponse.status} - ${errorText}`);
            }
            
            const removeResult = await removeResponse.json();
            console.log('Remove operation result:', removeResult);
        }
        
        if (addItems.length > 0) {
            console.log('Sending add request with items:', addItems);
            const addResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items: addItems })
            });
            
            if (!addResponse.ok) {
                const errorText = await addResponse.text();
                console.error('Add operation failed:', addResponse.status, errorText);
                throw new Error(`Failed to add items: ${addResponse.status} - ${errorText}`);
            }
            
            const addResult = await addResponse.json();
            console.log('Add operation result:', addResult);
        }
        
        console.log('All cart operations completed successfully');
        return true;
    } catch (error) {
        console.error('Error executing cart operations:', error);
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);
        throw error;
    }
}

async function rjSyncCartState() {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) return;
        
        const cart = await response.json();
        if (!cart.items || cart.items.length === 0) return;
        
        const productMap = {
            "52298416652563": "52298416652563",
            "52240139321619": "10102698443027", // Ronald Jenkees (RJCD1-RJ-DL)
            "52240139419923": "10102698508563", // Disorganized Fun (RJCD2-DF-DL)
            "52240139452691": "10102698541331", // Days Away (RJCD3-DA-DL)
            "52240139485459": "10102698574099", // Alpha Numeric (RJCD4-AN-DL)
            "52240139518227": "10102698606867", // Make It Fun Vol. 1 (RJ-4A-DL)
            "52240139550995": "10102698639635", // Rhodes Deep (RJCD4-RD-DL)
            "52298416652563": "52298416652563"  // Wonder and Flow (RJ-4A-DL)
        };
        
        const downloadItemsInCart = cart.items.filter(item => 
            Object.keys(productMap).includes(item.variant_id.toString())
        );
        
        if (downloadItemsInCart.length === 0) return;
        
        const hasBundle = downloadItemsInCart.some(item => item.variant_id.toString() === '42280848247443');
        if (hasBundle) {
            const bundleCheckbox = document.querySelector(`.rj-album-select-checkbox[value="RJCD-ALL-DL"]`);
            if (bundleCheckbox) {
                if (!bundleCheckbox.checked) {
                    bundleCheckbox.checked = true;
                }
                if (typeof rjUpdateBundleSelection === 'function') {
                    rjUpdateBundleSelection(bundleCheckbox);
                } else {
                    rjUpdateSelection(bundleCheckbox);
                }
            }
            return;
        }
        
        downloadItemsInCart.forEach(cartItem => {
            const productId = productMap[cartItem.variant_id.toString()];
            const checkbox = document.querySelector(`.rj-album-select-checkbox[value="${productId}"]`);
            
            if (checkbox && !checkbox.checked) {
                checkbox.checked = true;
                if (productId === 'RJCD-ALL-DL' && typeof rjUpdateBundleSelection === 'function') {
                    rjUpdateBundleSelection(checkbox);
                } else {
                    rjUpdateSelection(checkbox);
                }
            }
        });
        
        if (downloadItemsInCart.length > 0) {
            const message = downloadItemsInCart.length === 1 
                ? "✅ 1 download from your cart has been selected" 
                : `✅ ${downloadItemsInCart.length} downloads from your cart have been selected`;
            
            setTimeout(() => {
                rjShowToast(message, "success");
            }, 1000);
        }
        
    } catch (error) {
        console.log('Cart sync info:', error);
    }
}

// Load albums for vault redemption interface (no pricing/checkboxes)
function rjLoadDownloadss() {
    const container = document.getElementById("rj-albumContainer");
    if (!container) {
        console.error("RJ Album container not found!");
        return;
    }
    
    // If token flow is active, let it handle rendering; otherwise proceed and replace any loading placeholder
    const hasLoading = container.querySelector('.rj-loading');
    const hasTokenManager = window.vaultDownloadManager || window.vault;
    const isTokenFlow = !!(hasTokenManager && ((window.vaultDownloadManager && window.vaultDownloadManager.token) || (window.vault && window.vault.token)));
    const urlHasToken = new URLSearchParams(window.location.search).has('token');
    
    if (isTokenFlow || urlHasToken) {
        // Token-based vault flow renders its own UI; keep placeholder/loader visible until it swaps content
        return;
    }
    
    // Clear existing content only if no loading state
    container.innerHTML = '';
    
    // Reverse album order so newest is first (like original)
    const albumsToLoad = [...albums].reverse();
    
    albumsToLoad.forEach(album => {
        // Create wrapper div
        const wrapper = document.createElement("div");
        wrapper.classList.add("rj-album-wrapper");
        
        const albumDiv = document.createElement("div");
        albumDiv.classList.add("rj-album");
        
        // Store album colors data as attributes
        const colors = albumColors[album.name];
        if (colors) {
            albumDiv.dataset.primaryColor = colors.primaryColor;
            albumDiv.dataset.secondaryColor = colors.secondaryColor;
            albumDiv.dataset.textColor = colors.textColor;
            albumDiv.dataset.accentColor = colors.accentColor;
            albumDiv.dataset.year = colors.year;
        }
        
        const tracksHtml = album.tracks ? `
            <div class="rj-album-tracks" onclick="event.stopPropagation();">
                ${album.tracks.map((track, index) => `
                    <div class="rj-track" id="rj-track-${album.productId}-${index}" 
                        onclick="rjPlayPreview('${track.preview}', this, 'rj-track-${album.productId}-${index}', '${album.name}', event)"
                        ontouchend="rjPlayPreview('${track.preview}', this, 'rj-track-${album.productId}-${index}', '${album.name}', event)">
                        <span class="rj-track-number">${(index + 1).toString().padStart(2, '0')}</span>
                        <span class="rj-track-title">${track.title}</span>
                        <div class="rj-audio-wave">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                `).join('')}
            </div>
        ` : '';

        albumDiv.innerHTML = `
            <div class="rj-album-image">
                <img src="${album.cover}" alt="${album.name}" onerror="this.onerror=null; this.src=(window.RJ_ALBUM_COVERS_FALLBACK||this.src)">
            </div>
            <div class="rj-download-section">
                <span class="rj-download-text">Download MP3</span>
            </div>
            <div class="rj-album-info">
                <p>${album.name}</p>
                <span class="rj-track-count">${album.tracks ? album.tracks.length : 0} tracks</span>
            </div>
            <div class="rj-play-indicator">
                <svg class="rj-play-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 4v14l11-7z" fill="none" stroke="#888888" stroke-width="1.4" stroke-linejoin="round"/>
                </svg>
            </div>
            ${tracksHtml}
        `;
        
        wrapper.appendChild(albumDiv);
        container.appendChild(wrapper);
    });

    document.querySelectorAll('.rj-album').forEach(album => {
        album.addEventListener('click', function(event) {
            const wasExpanded = this.classList.contains('rj-expanded');
            const currentlyExpanded = document.querySelector('.rj-album.rj-expanded');

            if (currentlyExpanded && currentlyExpanded !== this) {
                currentlyExpanded.classList.remove('rj-expanded');
                rjStopAudio();
            }

            if (!wasExpanded) {
                this.classList.add('rj-expanding');
                
                setTimeout(() => {
                    this.classList.add('rj-expanded');
                    this.classList.remove('rj-expanding');
                }, 40);
                
                setTimeout(() => {
                    const albumRect = this.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    
                    if (albumRect.bottom > window.innerHeight - 200) {
                        const newPosition = scrollTop + albumRect.top - 120;
                        window.scrollTo({
                            top: newPosition,
                            behavior: 'smooth'
                        });
                    }
                }, 300);
                
                event.stopPropagation();
            } else {
                this.classList.add('rj-closing');
                
                setTimeout(() => {
                    this.classList.remove('rj-expanded');
                    
                    setTimeout(() => {
                        this.classList.remove('rj-closing');
                    }, 400);
                    
                    rjStopAudio();
                }, 40);
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.rj-vault-wrapper') && document.getElementById('rj-albumContainer')) {
        rjLoadDownloadss();
    }
    else if (document.querySelector('.rj-downloads-wrapper') && document.getElementById('rj-albumContainer')) {
        rjLoadAlbums();
        
        setTimeout(() => {
            rjSyncCartState();
        }, 400);
    }
    
    document.body.addEventListener('click', function(event) {
        const expandedAlbum = document.querySelector('.rj-album.rj-expanded');
        if (expandedAlbum && !event.target.closest('.rj-album')) {
            expandedAlbum.classList.remove('rj-expanded');
            rjStopAudio();
        }
    });
});

function rjPlayPreview(url, trackElement, trackId, albumName, event) {
    if (event) {
        event.stopPropagation();
        if (event.type === 'touchend') {
            event.preventDefault();
        }
    }
    
    const album = trackElement.closest('.rj-album');
    if (album && !album.classList.contains('rj-expanded')) {
        album.classList.add('rj-expanded');
    }
    
    const track = typeof trackElement === 'string' ? document.getElementById(trackElement) : trackElement;
    
    if (currentAudio && currentAudio.src === url) {
        if (currentAudio.paused) {
            try {
                currentAudio.load();
                const playPromise = currentAudio.play();
                
                if (playPromise !== undefined) {
                    playPromise
                    .then(() => {
                        track.classList.add('rj-playing');
                    })
                    .catch(error => {
                        console.error("Error resuming audio:", error);
                        track.classList.remove('rj-playing');
                        rjShowPlaybackError(track, "Tap again to play");
                    });
                }
            } catch (e) {
                console.error("Exception during audio playback:", e);
                track.classList.remove('rj-playing');
            }
        } else {
            currentAudio.pause();
            track.classList.remove('rj-playing');
        }
        return;
    }

    rjStopAudio();
    
    currentAudio = new Audio();
    currentAudio.crossOrigin = 'anonymous';
    currentAudio.preload = 'auto';
    currentAudio.src = url;
    
    let progressBar = track.querySelector('.rj-progress-bar');
    if (!progressBar) {
        progressBar = document.createElement('div');
        progressBar.className = 'rj-progress-bar';
        progressBar.id = trackId ? trackId + '-progress' : 'rj-track-progress-' + Math.random().toString(36).substr(2, 9);
        progressBar.style.cssText = `
            width: 0%;
            height: 3px;
            background-color: #5e95cb;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            will-change: width;
            transform: translateZ(0);
            backface-visibility: hidden;
        `;
        track.style.position = 'relative';
        track.appendChild(progressBar);
    } else {
        progressBar.style.width = '0%';
    }
    
    currentAudio.progressId = progressBar.id;
    
    // Debug event listeners to diagnose playback issues
    currentAudio.addEventListener('loadedmetadata', () => {
        console.log('Audio loadedmetadata', {
            src: currentAudio.src,
            duration: currentAudio.duration,
            readyState: currentAudio.readyState
        });
    });
    currentAudio.addEventListener('canplay', () => {
        console.log('Audio canplay', {
            readyState: currentAudio.readyState,
            networkState: currentAudio.networkState
        });
    });
    currentAudio.addEventListener('canplaythrough', () => console.log('Audio canplaythrough'));
    currentAudio.addEventListener('stalled', () => console.warn('Audio stalled'));
    currentAudio.addEventListener('suspend', () => console.warn('Audio suspend'));
    currentAudio.addEventListener('abort', () => console.warn('Audio abort'));
    currentAudio.addEventListener('progress', () => {
        console.log('Audio progress', {
            readyState: currentAudio.readyState,
            networkState: currentAudio.networkState
        });
    });

    currentAudio.addEventListener('timeupdate', rjUpdateProgress);
    currentAudio.addEventListener('ended', () => {
        track.classList.remove('rj-playing');
        rjStopAudio();
    });

    currentAudio.addEventListener('error', (e) => {
        const code = currentAudio && currentAudio.error ? currentAudio.error.code : null; // 1:MEDIA_ERR_ABORTED, 2:NETWORK, 3:DECODE, 4:SRC_NOT_SUPPORTED
        console.error("Audio error:", {
            event: e,
            code,
            readyState: currentAudio.readyState,
            networkState: currentAudio.networkState,
            src: currentAudio.src
        });
        track.classList.remove('rj-playing');
        const friendly = code === 4 ? "Cannot play file format" : "Audio error - try again";
        rjShowPlaybackError(track, friendly);
    });

    track.classList.add('rj-attempting-play');
    
    try {
        currentAudio.load();
        const playPromise = currentAudio.play();
        
        if (playPromise !== undefined) {
            playPromise
            .then(() => {
                track.classList.remove('rj-attempting-play');
                track.classList.add('rj-playing');
                
                // Trigger background color transition using shared background system
                if (albumName && window.rjSharedBackground) {
                    window.rjSharedBackground.transitionToAlbum(albumName);
                }
            })
            .catch((error) => {
                console.error("Error playing audio:", error);
                track.classList.remove('rj-attempting-play');
                track.classList.remove('rj-playing');
                
                rjShowPlaybackError(track, "Tap to play");
                
                const retryPlay = function(e) {
                    e.stopPropagation();
                    if (e.type === 'touchend') {
                        e.preventDefault();
                    }
                    
                    track.classList.add('rj-attempting-play');
                    currentAudio.load();
                    currentAudio.play()
                        .then(() => {
                            track.classList.remove('rj-attempting-play');
                            track.classList.add('rj-playing');
                            track.removeEventListener('click', retryPlay);
                            track.removeEventListener('touchend', retryPlay);
                        })
                        .catch((innerError) => {
                            console.error("Retry failed:", innerError);
                            track.classList.remove('rj-attempting-play');
                            track.classList.remove('rj-playing');
                        });
                };
                
                track.addEventListener('click', retryPlay, { once: true });
                track.addEventListener('touchend', retryPlay, { once: true });
            });
        }
    } catch (e) {
        console.error("Exception during audio playback:", e);
        track.classList.remove('rj-attempting-play');
        track.classList.remove('rj-playing');
        rjShowPlaybackError(track, "Audio error");
    }
}

function rjShowPlaybackError(trackElement, message) {
    const existingError = trackElement.querySelector('.rj-playback-error');
    if (existingError) {
        existingError.remove();
    }
    
    const errorMsg = document.createElement('div');
    errorMsg.className = 'rj-playback-error';
    errorMsg.textContent = message;
    errorMsg.style.cssText = `
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #ff5252;
        font-size: 12px;
        font-weight: 500;
        padding: 4px 8px;
        border-radius: 4px;
        background: rgba(255,255,255,0.9);
        z-index: 3;
        will-change: opacity;
        transform: translateY(-50%) translateZ(0);
    `;
    
    trackElement.appendChild(errorMsg);
    
    setTimeout(() => {
        if (errorMsg.parentNode === trackElement) {
            errorMsg.remove();
        }
    }, 3000);
}

function rjStopAudio() {
    if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        document.querySelectorAll('.rj-track.rj-playing').forEach(track => {
            track.classList.remove('rj-playing');
        });
        currentAudio = null;
    }

    document.querySelectorAll('.rj-audio-progress').forEach(progressBar => {
        progressBar.remove();
    });
}

function rjUpdateProgress() {
    if (!currentAudio || !currentAudio.progressId) return;

    requestAnimationFrame(() => {
        const progressElement = document.getElementById(currentAudio.progressId);
        if (!progressElement) return;
        const progress = (currentAudio.currentTime / currentAudio.duration) * 100;
        progressElement.style.width = `${progress}%`;
    });
}
